import {createApi} from "@reduxjs/toolkit/query/react";
import {baseQueryWithReAuth} from "@/store/api/baseQueryWithReAuth";

export interface StatePrice {
    id: number;
    amount: number;
    status?: number;
    business_type_id?: number;
    package?: number;
    state?: number;
    state_name?: string;
    package_name?: string;
    business_type_name?: string;
}

export const statePriceApi = createApi({
    reducerPath: "statePriceApi",
    baseQuery: baseQueryWithReAuth,
    endpoints: (builder) => ({
        getStatePrice: builder.query<StatePrice[], void>({
            query: () => "/state-price"
        })
    })
})

export const {useGetStatePriceQuery} = statePriceApi;